import { ControlledCustomSwitch } from 'components/TasksV2/UI/ControlledCustomSwitch'
import useLocaleText from 'components/useLocaleText'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { SettingItem } from './SettingItem'

interface AllowCompletionAfterDeadlineSwitchProps {
  number: number
}

export const AllowCompletionAfterDeadlineSwitch: React.FC<AllowCompletionAfterDeadlineSwitchProps> = ({ number }) => {
  const { control } = useFormContext()

  const t_allowCompletionAfterDeadline =
    useLocaleText('allow_completion_after_deadline') || 'Allow completion after deadline'

  return (
    <SettingItem
      number={number}
      title={t_allowCompletionAfterDeadline}
      control={
        <Controller
          as={ControlledCustomSwitch}
          name="allow_completion_after_deadline"
          control={control}
          valueName="isChecked"
          size="lg"
          onChange={([event]) => {
            return event.target.checked
          }}
        />
      }
    />
  )
}
